import React from 'react';
import IconBase from './Icon-base';
export default class Print extends React.Component {
    render() {
        return (
            <IconBase width="30" height="30" viewBox="0 0 30 30" {...this.props}>
                <desc>Created using Figma</desc>
                <g id="Canvas" transform="translate(-172 235)">
                    <g id="Group 5">
                        <g id="Vector">
                            <use
                                xlinkHref="#path0_stroke_pr"
                                transform="matrix(-1 0 0 1 195.75 -234)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Vector 2">
                            <use
                                xlinkHref="#path1_stroke_pr"
                                transform="translate(181.687 -219.378)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Subtract">
                            <use
                                xlinkHref="#path2_fill_pr"
                                transform="translate(172 -228.4)"
                                fill="#4F5056"
                            />
                        </g>
                    </g>
                </g>
                <defs>
                    <path
                        id="path0_stroke_pr"
                        d="M 0 0L 0 -0.5L -0.5 -0.5L -0.5 0L 0 0ZM 16.875 0L 17.375 0L 17.375 -0.5L 16.875 -0.5L 16.875 0ZM 16.875 28L 16.875 28.5L 17.375 28.5L 17.375 28L 16.875 28ZM 6.875 28L 6.52223 28.3543L 6.66855 28.5L 6.875 28.5L 6.875 28ZM 0 21.1556L -0.5 21.1556L -0.5 21.3633L -0.352765 21.5099L 0 21.1556ZM 6.875 21.1556L 7.375 21.1556L 7.375 20.6556L 6.875 20.6556L 6.875 21.1556ZM 0.5 4.97778L 0.5 0L -0.5 0L -0.5 4.97778L 0.5 4.97778ZM 0 0.5L 16.875 0.5L 16.875 -0.5L 0 -0.5L 0 0.5ZM 16.375 0L 16.375 4.97778L 17.375 4.97778L 17.375 0L 16.375 0ZM 16.375 14L 16.375 28L 17.375 28L 17.375 14L 16.375 14ZM 16.875 27.5L 6.875 27.5L 6.875 28.5L 16.875 28.5L 16.875 27.5ZM 7.22777 27.6457L 0.352765 20.8012L -0.352765 21.5099L 6.52223 28.3543L 7.22777 27.6457ZM 0.5 21.1556L 0.5 14L -0.5 14L -0.5 21.1556L 0.5 21.1556ZM 0 21.6556L 6.875 21.6556L 6.875 20.6556L 0 20.6556L 0 21.6556ZM 6.375 21.1556L 6.375 28L 7.375 28L 7.375 21.1556L 6.375 21.1556Z"
                    />
                    <path
                        id="path1_stroke_pr"
                        d="M 0 4.23333L 9.6875 4.23333L 9.6875 3.23333L 0 3.23333L 0 4.23333ZM 0 0.5L 9.6875 0.5L 9.6875 -0.5L 0 -0.5L 0 0.5Z"
                    />
                    <path
                        id="path2_fill_pr"
                        fillRule="evenodd"
                        d="M 3 0C 1.34315 0 0 1.34314 0 3L 0 13.0667L 6.5625 13.0667L 6.5625 11.2L 5.625 11.2L 5.625 7.2222L 25 7.2222L 25 11.2L 24.0625 11.2L 24.0625 13.0667L 30 13.0667L 30 3C 30 1.34314 28.6569 0 27 0L 3 0Z"
                    />
                </defs>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/Print.js